module.exports = __webpack_public_path__ + "static/media/cse.c4c3eda6.png";